export default __webpack_public_path__ + "5aba92683bd44ca02330aef2d2ac7e4e.png";